module.exports = __webpack_public_path__ + "static/media/cyber-corn-explosion-3.985f1daf.jpg";